<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card :title="`${id ? '编辑' : '添加'}折扣服务`">
                <a-form :form="form" style="width: 600px">

                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 名称:</span>
                        <a-input
                            v-decorator="[`title`, { rules: [{ required: true, message: '请输入名称' }] }]"
                            placeholder="请输入名称"
                        />
                    </a-form-item>

                </a-form>
                <a-button type="primary" @click="sub">
                    提交
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>

<script>

const EditableCell = {
    template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
    props: {
        text: String
    },
    data() {
        return {
            value: this.text,
            editable: false
        }
    },
    methods: {
        handleChange(e) {
            const value = e.target.value
            this.value = value
        },
        check() {
            this.editable = false
            this.$emit('change', this.value)
        },
        edit() {
            this.editable = true
        }
    }
}
import editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import '../../../public/tinymce/axupimgs'
import Discounts from '@api/Discounts'
export default {
    name: 'newEdit',
    components: {
        editor,
        EditableCell
    },
    data() {
        return {
            formone: this.$form.createForm(this),
            dataYi: [],
            dataEr: [],
            previewVisible: false,
            visible: false,
            visible2: false,
            visibleshop: false,
            visibleshoper: false,


            count: 0,
            counter: 0,



            previewImage: '',
            fileList: [],
            fileList1: [],
            fileList2: [],
            fileListbanner: [
                /*{
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
                },*/
            ],
            //45564
            form: this.$form.createForm(this),
            loading: this.$route.query.id ? true : false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 3 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 }
            },
            pic: '',
            id: this.$route.query.id || undefined,
            init: {
                language_url: `https://zuji.ahxunbu.com/tinymce/langs/zh_CN.js`, //语言包的路径
                language: 'zh_CN', //语言
                skin_url: `https://zuji.ahxunbu.com/tinymce/skins/ui/oxide`, //skin路径
                height: 500, //编辑器高度
                branding: false, //是否禁用“Powered by TinyMCE”
                menubar: false, //顶部菜单栏显示
                plugins: 'image axupimgs media',
                convert_urls: false,
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImgUpload(blobInfo, success, failure)
                },
                toolbar:
                    'axupimgs | undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
            },
            content: '',
            img: '',
            value: '',
            title_img: '',
            second: '',
            searchData: {
                cat_id: undefined,
                type: undefined,
                zuday: undefined
            },
            orderStatus: [],
            fenlei: [],
            shop: [],
            addtype: '',
            name: '',
            Yikey: '',
            addkey: '',
            Save: false,
            SaceKey: ''
        }
    },
    mounted() {
        if (this.id) {
            this.getOne()
        }
    },
    methods: {


        getSave(data) {
            this.visible = true
            this.Save = true
            this.SaceKey = data.key

            this.$nextTick(() => {
                this.formone.setFieldsValue({
                    title: data.title
                })
            })
        },


        getSave2(data) {
            this.visible2 = true
            this.Save = true
            this.SaceKey = data.key

            this.$nextTick(() => {
                this.formone.setFieldsValue({
                    title: data.title,
                })
            })
        },
        getDel(data) {
            this.dataEr.some((item, i) => {
                if (item.key == data.key) {
                    this.dataEr.splice(i, 1)
                    /// some循环如果true,就会终止后续循环
                    return true
                }
            })
        },
        getDelOne(data) {
            this.dataYi.some((item, i) => {
                if (item.key == data.key) {
                    this.dataYi.splice(i, 1)
                    this.title = ''
                    /// some循环如果true,就会终止后续循环
                    return true
                }
            })
        },

        handleAdd() {
            this.visible = true
        },
        getquxiao() {
            this.formone.resetFields()
            this.Save = false
        },
        getquxiao2() {
            this.formone.resetFields()
            this.Save = false
        },
        getOkor() {
            this.formone.validateFields((err, values) => {
                if (!values.name) {
                    return
                }
                if (values.name) {
                    this.form.validateFields((err, val) => {
                        if (val.day) {
                            if ((values.name / val.day) % 1 === 0) {
                                if (this.Save) {
                                    this.dataYi.map(item => {
                                        if (item.key == this.SaceKey) {
                                            item.name = values.name
                                            item.key = this.count
                                            item.list = item.list
                                            this.name = values.name
                                            this.dataEr = item.list
                                            this.Yikey = this.count
                                        }
                                        return item
                                    })
                                } else {
                                    this.dataYi.push({
                                        name: values.name,
                                        key: this.count
                                    })
                                }
                                this.formone.setFieldsValue({
                                    name: ''
                                })
                                this.count++
                                this.visible = false
                                this.Save = false
                                // console.log(this.dataYi)
                            } else {
                                this.$message.info('请填写单期期数倍数')
                                return
                            }
                        } else {
                            this.$message.info('请填写单期期数')
                            return
                        }
                    })
                }
            })
        },
        getdels(Promise) {
            for (let i = 0; i < this.fileListbanner.length; i++) {
                if (Promise.uid == this.fileListbanner[i].uid) {
                    this.fileListbanner.splice(i, 1)
                }
            }
        },
        handleChangess(e, type) {
            console.log(e)
            let file = e.file
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    // this.pic = res.data.url
                    if (this.fileListbanner.length > 0) {
                        let arr = []
                        for (let i = 0; i < this.fileListbanner.length; i++) {
                            arr.push(this.fileListbanner[i].uid)
                        }
                        let minInNumbers = Math.min.apply(Math, arr)
                        this.fileListbanner.push({
                            url: res.result,
                            uid: minInNumbers - 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    } else {
                        this.fileListbanner.push({
                            url: res.result,
                            uid: this.fileListbanner.length + 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    }
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },

        getOne() {
            Discounts.FindDiscounts({ id: this.id }).then(res => {
                this.loading = false
                this.$nextTick(() => {

                    this.form.setFieldsValue({
                        title: res.reuslt.title

                    })


                    // console.log('数组', this.dataYi)
                })
            })
        },

        sub() {
            let arr = []
            for (let i = 0; i < this.fileListbanner.length; i++) {
                arr.push(this.fileListbanner[i].url)
            }
            /* let Aname = []
            if (this.dataYi.length == 0) {
                this.$message.info('请填写规格')
                return
            } else {
                for (let i = 0; i < this.dataYi.length; i++) {
                    Aname.push(this.dataYi[i].name)
                }
            } */
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    Discounts[this.id ? `SaveDiscounts` : `AddDiscounts`]({
                        ...values,
                        id: this.id,
                    })
                        .then(res => {
                            this.loading = false
                            this.$router.back()
                        })
                        .catch(res => {
                            this.loading = false
                        })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }

        video {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }
    }
}

.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.editCon {
    margin-bottom: 20px;
    position: relative;

    .editCon {
        position: absolute;
        z-index: 1;
        top: 3px;
        right: 5px;
    }
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}
</style>
<style>
.tox-tinymce-aux {
    z-index: 9999999 !important;
}
.tox-menu {
    z-index: 9999999 !important;
    top: 780px !important;
    max-height: 1000px !important;
}
.tox-collection__group {
    z-index: 9999999 !important;
}
</style>
